import $ from 'jquery'
import Toggle from "./Toggle";

$(document).ready(() => {
  new Toggle()
})
